import { Faqs } from '@time-line/components/blocks';
import { RichTextResolver } from 'components/common/RichTextResolver';
import * as routes from 'lib/constants/routes';
import type { Faqs as FaqsBlockProps } from 'types/cms/blocks/Faqs';

export function FaqsBlock({
  title,
  list,
  subtitle,
  isFAQLinkEnabled,
}: FaqsBlockProps) {
  return (
    <Faqs
      title={title}
      list={list}
      RichTextResolver={RichTextResolver}
      withBackground={false}
      seeAllQuestionsHref={isFAQLinkEnabled ? routes.FAQ : undefined}
      subtitle={subtitle}
    />
  );
}
